var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko let: { $props: props } --> <div data-bind="foreach: $props.groups, css: $props.classNames"> <p class="nfd-dropdown-group-list-title nfd-dropdown-group-list-title-pretty"data-bind="text: groupTitle"></p> <ul class="nfd-dropdown-list"data-bind="foreach: items"> <li class="nfd-dropdown-group-list-item nfd-dropdown-group-list-item-hovered nfd-dropdown-group-list-item-padded"data-bind="click: $props.onItemClick.bind(null, $parent.groupId)"> <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko --> </li> </ul> </div> <!-- /ko -->';
}
return __p;
};
